import { render, staticRenderFns } from "./permissionSettings-G.vue?vue&type=template&id=8723bc84&scoped=true&"
import script from "./permissionSettings-G.vue?vue&type=script&lang=js&"
export * from "./permissionSettings-G.vue?vue&type=script&lang=js&"
import style0 from "./permissionSettings-G.vue?vue&type=style&index=0&id=8723bc84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8723bc84",
  null
  
)

export default component.exports